import $ from "jquery";

$(function () {
    $(".bl-teamlist").each(function () {
        initBlock($(this));
    });
});

function initBlock($bl) {
    const $items = $bl.find(".items");
    $items.on("mouseenter touchstart", ".item", function() {
        $(this).addClass("active");
    });
    $items.on("mouseleave", ".item", function() {
        $(this).removeClass("active");
    });
    $items.on("touchstart", ".item", function() {
        $bl.find(".item").removeClass("active");
        $(this).addClass("active");
    });
}
